'use client';
import { useState } from 'react';
import { CategoryCard } from '../cards';
import Title from '../typography/title';
import Container from '@/components/ui/container';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay } from 'swiper/modules';

// used in home page and category page

const CategoriesSlider = ({ data, isMobile, locale, fromCategoryPage }) => {
  const [swiper, set_swiper] = useState({});
  const [isBeginning, setIsBeginning] = useState(true);
  const [isEnd, setIsEnd] = useState(false);
  return (
    <Container className='my-8 py-0 max-md:my-4 max-sm:my-0'>
      <Title
        locale={locale}
        isMobile={isMobile}
        swiper={swiper}
        title={data?.[`title-${locale}`]}
        data={data}
        slidesNo={swiper?.slides?.length}
        isBeginning={isBeginning}
        isEnd={isEnd}
        fromCategory
      />

      <div className='mt-6 w-full max-md:mt-2.5 max-sm:-mt-1'>
        <Swiper
          onInit={(e) => set_swiper(e)}
          dir={locale === 'ar' ? 'rtl' : 'ltr'}
          slidesPerView='auto'
          onSlideChange={(swiper) => {
            setIsBeginning(swiper.isBeginning);
            setIsEnd(swiper.isEnd);
          }}
          onSwiper={(swiper) => {
            setIsBeginning(swiper.isBeginning);
            setIsEnd(swiper.isEnd);
          }}
          modules={[Autoplay]}
          autoplay={{ delay: 4000, pauseOnMouseEnter: true }}
          breakpoints={{
            320: { spaceBetween: 10 },
            640: { spaceBetween: 15 },
            1023: { spaceBetween: 24 },
            1280: { spaceBetween: 24, slidesPerView: 6 },
            1536: { spaceBetween: 70, slidesPerView: 6 },
            1800: { spaceBetween: 65, slidesPerView: 6 },
            2100: { spaceBetween: 90, slidesPerView: 6 },
          }}
        >
          {data?.value?.map((info, i) => (
            <SwiperSlide
              key={i}
              className='max-w-46.5 min-w-46.5 max-md:max-w-42 max-md:min-w-42 max-sm:max-w-30.5 max-sm:min-w-30.5'
            >
              <CategoryCard
                isMobile={isMobile}
                info={info}
                fromCategoryPage={fromCategoryPage}
              />
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </Container>
  );
};

export default CategoriesSlider;
